import { render, staticRenderFns } from "./doctorGroup.vue?vue&type=template&id=df7bd1a8&scoped=true"
import script from "./doctorGroup.vue?vue&type=script&lang=js"
export * from "./doctorGroup.vue?vue&type=script&lang=js"
import style0 from "./doctorGroup.vue?vue&type=style&index=0&id=df7bd1a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7bd1a8",
  null
  
)

export default component.exports